import React from 'react'
import { MainHeading, PageHeaderIntro, FindAgent, Breadcrumb, FigureCards, Faq, NewsCard } from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';
import './equipment-breakdown-coverage.scss'

const EquipmentBreakdown = () => {

    const HeaderData = [
        {
            image: images['Icon_blue_two_people_moving_box.svg'],
            para: 'It’s easy to take your equipment for granted when it’s running smoothly. But when breakdowns happen, your foresight and coverage plan can be the difference between a minor hiccup and weeks of lost productivity. Choosing the right equipment insurance is a key step in protecting your business.',
            para1: 'We know that preventing a major breakdown isn’t always possible. But when the unexpected becomes very real—and very urgent—our equipment breakdown insurance can help you reduce your costs and get back to work sooner.'
        },
    ];
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        // { label: "Commercial property insurance", link: "/what-we-offer/insurance-products/commercial-property-insurance" },
        { label: "Equipment breakdown coverage", link: "/what-we-offer/insurance-products/shared-insurance-products/equipment-breakdown-coverage" },
    ];
    const faqData = [
        {
            id: 1,
            eventKey: 1,
            header: 'I’m familiar with boiler and machinery insurance, but what else does equipment breakdown insurance cover?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 2,
            eventKey: 2,
            header: 'How does Sentry’s equipment breakdown insurance compare to the industry standard?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 3,
            eventKey: 3,
            header: 'I’m looking for the right balance of protection and value for my business and property—does equipment breakdown coverage make sense for me?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        }
    ]
    const featuredCard = [
        {
            id: 1,
            value: "5k+",
            unit: "Sentry associates",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 2,
            value: "8",
            unit: "Sentry leaders",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 3,
            value: "1992",
            unit: "First year",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
    ];
    const NewsCardData = [
        {
            id: 1,
            title: 'Getting your employees ready to retire',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'Read more >',
        },
        {
            id: 2,
            title: 'Secure Act 2.0',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'Read more >',
        },
        {
            id: 3,
            title: 'Sentry news',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'Read more >',
        },

    ];
    return (
        <div className='equipment-breakdown-coverage-main'>
            <Container>
                {/* Breadcrum */}
                <Breadcrumb crumbs={breadcrumbs} />

                {/* heading  */}
                <MainHeading title="Equipment breakdown coverage" showshare={false} />

                {/* page intro */}
                <PageHeaderIntro Data={HeaderData} />

                <Faq heading="FAQs" FaqData={faqData} />

                <FigureCards data={featuredCard} heading="Significant figures" />

                {/* news card section */}
                <NewsCard Title="More reasons to choose Sentry" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />

                <FindAgent />
            </Container>
        </div>
    )
}

export default EquipmentBreakdown;